var React = require('react');

function TriangleArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M611.61 436.66C608.783 429.733 605.492 423.005 601.76 416.52C532.92 296.727 463.953 177.01 394.86 57.3702C387.86 45.2702 379.53 33.1801 369.33 23.7701C328.66 -13.7299 264.38 -4.72994 235.84 43.7701C160.76 171.357 86.4801 299.407 13.0001 427.92C-19.3299 484.61 15.2601 551 77.5501 559H245.13C245.2 513.91 245.31 427.84 245.31 427.84C245.31 427.84 226.95 427.65 202.14 427.65C176.87 427.65 171.66 418.73 184.14 396.91C220.473 333.37 257.207 270.067 294.34 207C305.34 188.27 315.13 186.62 327.18 207.45C363.84 270.87 400.61 334.21 436.78 397.9C448.34 418.23 443.11 427.13 419.78 427.9C395.73 427.9 375.17 427.9 375.17 427.9V559H547.17C603.88 549.08 634.75 493.45 611.61 436.66Z","fill":"white"}));
}

TriangleArrowInline.defaultProps = {"width":"620","height":"559","viewBox":"0 0 620 559","fill":"none"};

module.exports = TriangleArrowInline;

TriangleArrowInline.default = TriangleArrowInline;
